import type { Audience } from '../../auth/roles';

/**
 * Whether this audience is offered mutes at all (A18): ops only, for every
 * source kind.
 *
 * A mute silences a device for every reader of the site, sweeps its open
 * alerts closed and can run "until unmuted", so it is Nexsoss's verb. A
 * site audience gets no "Mute device…", no Muted devices list (whose rows
 * are raw kinds and ids) and no mute dialog. The server refuses the write
 * the same way (`api/alerts.py::_require_ops_audience`). The site's lift
 * control (`lift_write_gate`, A14) was the first kind held back like this
 * (F3); it is now the rule for every kind.
 *
 * Its own module, not `AlertsScreen.tsx`: a component module that also
 * exports a function fails `react-refresh/only-export-components`, and
 * any new mute surface gates on this one function.
 */
export function offersMutes(audience: Audience): boolean {
  return audience === 'ops';
}

/** The mute dialog's note: who else sees a mute, and who can lift it. */
export const MUTE_DIALOG_HINT =
  'While muted, this device opens no new alerts and its open alerts are resolved. A recovered device still closes its own alerts. Only Nexsoss staff see the muted list and can unmute it.';
